/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";
import { MICROSOFT_APPLICATION_CLIENT_ID, MICROSOFT_APPLICATION_TENANT_ID } from "../components/services/global";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */

export const msalConfig = {
    auth: {
        clientId: MICROSOFT_APPLICATION_CLIENT_ID,
        authority: "https://login.microsoftonline.com/" + MICROSOFT_APPLICATION_TENANT_ID,
        redirectUri: "/msLogin",
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
              // console.log('logger callback', level, message, containsPii)
                if (containsPii) {		
                    return;		
                }		
                switch (level) {
                    case LogLevel.Error:
                        // console.error(message);
                        if (message.toLowerCase().includes("window closed")) {
                          if (localStorage.getItem("msLogin") === "1") localStorage.setItem('logoutfailure', 'window closed');
                        }
                        return message;
                    case LogLevel.Info:
                        // console.info(message);
                        return message;
                    case LogLevel.Verbose:
                        // console.debug(message);
                        return message;
                    case LogLevel.Warning:
                        // console.warn(message);
                        return message;
                    default:
                        return message;
                }	
            }	
        }	
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["User.Read"],
    prompt: "select_account"
};

export const logoutRequest = {
  postLogoutRedirectUri: "/home"
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};
